/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigation API
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { RoutineFilterRequest } from '../models';
import { RoutineViewIEnumerableResponse } from '../models';
/**
 * RoutineApi - axios parameter creator
 * @export
 */
export const RoutineApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TA All | Returns Routines
         * @param {RoutineFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2RoutineGetRoutinesPost: async (body?: RoutineFilterRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/Routine/GetRoutines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RoutineApi - functional programming interface
 * @export
 */
export const RoutineApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TA All | Returns Routines
         * @param {RoutineFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2RoutineGetRoutinesPost(body?: RoutineFilterRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoutineViewIEnumerableResponse>> {
            const localVarAxiosArgs = await RoutineApiAxiosParamCreator(configuration).apiV2RoutineGetRoutinesPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * RoutineApi - factory interface
 * @export
 */
export const RoutineApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary TA All | Returns Routines
         * @param {RoutineFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2RoutineGetRoutinesPost(body?: RoutineFilterRequest, options?: any): AxiosPromise<RoutineViewIEnumerableResponse> {
            return RoutineApiFp(configuration).apiV2RoutineGetRoutinesPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RoutineApi - object-oriented interface
 * @export
 * @class RoutineApi
 * @extends {BaseAPI}
 */
export class RoutineApi extends BaseAPI {
    /**
     * 
     * @summary TA All | Returns Routines
     * @param {RoutineFilterRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoutineApi
     */
    public apiV2RoutineGetRoutinesPost(body?: RoutineFilterRequest, options?: any) {
        return RoutineApiFp(this.configuration).apiV2RoutineGetRoutinesPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
